<script>
    import Loader from "../components/Loader.svelte";
    import {onMount} from 'svelte';
    import AlteryxService from "../services/alteryx.service";

    let emails;
    let loading = false;
    let loadingEmails = false;
    let message = {
        show: false,
        type: "",
        text: ""
    }
    let errors = [];
    let duplicates = [];

    onMount( async () => {
        await getAlteryxEmails();
    });

    let getAlteryxEmails = async function() {
        loading = true;
        try {
            const response = await AlteryxService.getEmails();

            if (response) emails = response;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

    let updateEmails = async function() {
        loading = true;
        try {
            const response = await AlteryxService.updateEmails({emails});

            if (response && response.data.ok) {
                message = {
                    show: true,
                    text: "Email accounts updated",
                    type: "success"
                }
            }else{
                message = {
                    show: true,
                    text: "Error: " + response.data.error,
                    type: "danger"
                }
            }
            await getAlteryxEmails();
        } catch (e) {
            message = {
                show: true,
                text: "Error: " + e.message,
                type: "danger"
            }
        } finally {
            loading = false;
        }
    }

    let resetMessage = function(){
        message = {
            show: false,
            text: "",
            type: ""
        }
    }

    $: {
        if(emails){
            let emailsArray = emails.split(', ');
            errors = emailsArray.filter(email => !email.includes('@') || !email.includes('.') || email.indexOf('.') === email.length - 1  || email.includes(' '));
            duplicates = emailsArray.filter((email, index, self) => self.indexOf(email) !== index);
            if (errors.length > 0 || duplicates.length > 0) {
                message = {
                    show: true,
                    text: "Error: " + (errors.join(', ') + (duplicates.length > 0 ? ', Duplicate emails: ' + duplicates.join(', ') : '')),
                    type: "danger"
                }
            }else{
                message = {
                    show: false,
                    text: "",
                    type: ""
                }
            }
        }
    }

</script>

{#if loadingEmails}
    <Loader fixed={false}></Loader>
{:else}
    {#if message.show}
        <div class="alert alert-{message.type} mt-3" id="message" role="alert">
            {message.text}
            <span class="float-right pointer" on:click={ resetMessage }>x</span>
        </div>
    {/if}
    <hr>
    <div class="row">
        <div class="col-md-12">
            <label>Email recipients:</label>
            <textarea id="emails-textarea" type="text" bind:value={emails} placeholder="example1@mail.com, example2@mail.com ..." class="form-control"></textarea>
            <p><small>Input email accounts separated by a comma</small></p>
            <button class="btn btn-success mt-2" on:click={ updateEmails } disabled={loading || errors.length > 0 || duplicates.length > 0}>Update</button>
        </div>
    </div>
{/if}
